import ProductPageContainer from "../../Componant/Ecommerce/ProductPage";

const ProductPage = () => {
  return (
    <div className="page-body">
      <ProductPageContainer />
    </div>
  );
};

export default ProductPage;
